interface ProjectErrors {
  type?: string[]
  project_name?: string[]
  project_billable?: string[]
  project_legal_entity?: string[]
  project_code?: string[]
  project_description?: string[]
  project_start_date?: string[]
  project_due_date?: string[]
  project_fixed_cost?: string[]
  planned_hours?: string[]
  planned_cost?: string[]
  planned_income?: string[]
  subproject_names?: string[]
  project_status?: string[]
}

export interface ProjectsToImport {
  type: string
  project_name: string
  project_billable: boolean
  project_legal_entity: string
  project_code: string | null
  project_description: string | null
  project_start_date: string | null
  project_due_date: string | null
  project_fixed_cost: number | null
  planned_hours: number | null
  planned_cost: number | null
  planned_income: number | null
  subproject_names: string[]
  project_status: string
  errors: ProjectErrors
}

export enum ImportedProjectProps {
  type = 'type',
  project_name = 'project_name',
  project_billable = 'project_billable',
  project_legal_entity = 'project_legal_entity',
  project_code = 'project_code',
  project_description = 'project_description',
  project_start_date = 'project_start_date',
  project_due_date = 'project_due_date',
  project_fixed_cost = 'project_fixed_cost',
  planned_hours = 'planned_hours',
  planned_cost = 'planned_cost',
  planned_income = 'planned_income',
  subproject_names = 'subproject_names',
  project_status = 'project_status',
}

export type chartDataTarget = 'employees' | 'projects' | 'subprojects'
